module.exports = __webpack_public_path__ + "assets-cabinet/img/cabinet.crederes.com.cfbc6922.svg";